// @flow

import Resource from 'speed-js-core/src/api/NestedResource';

export default class SiteResource extends Resource {
    basePath: string = 'clients/clients/{parent}/sites/';

    objectPath: string = 'clients/clients/{parent}/sites/{ident}/';
}
